import { SHARE_MAX_EQUATION_NODES } from "./share-document";

type MigratedTupleBody = [
  unknown,
  unknown,
  unknown,
  unknown,
  unknown,
  unknown,
  unknown,
  unknown,
];

export function decodeTuple(value: unknown, length: number): unknown[] {
  if (!Array.isArray(value) || value.length !== length)
    throw new Error("Invalid share payload shape");
  return value;
}

export function decodeBoundedArray(value: unknown): unknown[] {
  if (!Array.isArray(value) || value.length > SHARE_MAX_EQUATION_NODES)
    throw new Error("Invalid share collection");
  return value;
}

export function migrateVersion1(value: unknown): MigratedTupleBody {
  const [
    ,
    activeDimension,
    showBasis,
    animationMode,
    animationActive,
    elapsedMs,
    equation2,
    equation3,
    camera2,
    camera3,
  ] = decodeTuple(value, 10);
  return [
    activeDimension,
    showBasis,
    1,
    playbackTuple(animationMode, animationActive, elapsedMs),
    upgradeLegacyEquation(equation2),
    upgradeLegacyEquation(equation3),
    camera2,
    camera3,
  ];
}

export function migrateVersion2(value: unknown): MigratedTupleBody {
  const [
    ,
    activeDimension,
    showBasis,
    showGrid,
    animationMode,
    animationActive,
    elapsedMs,
    equation2,
    equation3,
    camera2,
    camera3,
  ] = decodeTuple(value, 11);
  return [
    activeDimension,
    showBasis,
    showGrid,
    playbackTuple(animationMode, animationActive, elapsedMs),
    upgradeLegacyEquation(equation2),
    upgradeLegacyEquation(equation3),
    camera2,
    camera3,
  ];
}

function playbackTuple(
  mode: unknown,
  active: unknown,
  elapsedMs: unknown,
): unknown[] {
  return active === 0 ? [0, mode] : [active, mode, elapsedMs];
}

function upgradeLegacyEquation(value: unknown): unknown[] {
  const equation = decodeTuple(value, 3);
  const matrices = decodeBoundedArray(equation[0]).map((entry) => {
    const matrix = decodeTuple(entry, 4);
    return [matrix[0], normalizeLegacyDrafts(matrix[1]), matrix[3]];
  });
  const vectors = decodeBoundedArray(equation[1]).map((entry) => {
    const vector = decodeTuple(entry, 4);
    return [vector[0], normalizeLegacyDrafts(vector[1]), vector[3]];
  });
  return [matrices, vectors, equation[2]];
}

function normalizeLegacyDrafts(value: unknown): unknown {
  if (!Array.isArray(value)) return value;
  const drafts: unknown[] = value;
  return drafts.map((draft) =>
    typeof draft === "string"
      ? draft.replace(/[A-Za-z]+/g, (identifier) => identifier.toLowerCase())
      : draft,
  );
}
